/* eslint-disable @typescript-eslint/no-explicit-any */
import { getClarityMetadataSnapshot } from "@/lib/clarityMetadata";

export default class IdentifierService {
  static getGAId = async () => {
    if (typeof window !== "undefined") {
      const cookies = document.cookie.split("; ").reduce((acc: any, cookie) => {
        const [key, value] = cookie.split("=");
        acc[key] = decodeURIComponent(value);
        return acc;
      }, {});
      const gaValue = cookies["_ga"];
      return gaValue ? gaValue.split(".")[2] : null;
    }
  };

  static getClarityUserId = (): {
    clarityUserId: string | null;
    claritySessionId: string | null;
    clarityProjectId: string | null;
  } | null => {
    if (typeof window === "undefined" || !window.clarity) return null;
    const md = getClarityMetadataSnapshot();
    return {
      clarityUserId: md.userId,
      claritySessionId: md.sessionId,
      clarityProjectId: md.projectId,
    };
  };
}
